"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgScissors = function SvgScissors(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M19 14a4 4 0 013.447 6.031L25 22.585l7.293-7.292a1 1 0 011.414 1.414L22.447 27.97a4 4 0 11-1.416-1.416L23.585 24l-2.554-2.553A4 4 0 1119 14zm9.176 11.772l5.53 5.52a1 1 0 01-1.412 1.416l-5.53-5.52a1 1 0 011.412-1.416zM19 28a2 2 0 101.413.587l-.018-.02A1.993 1.993 0 0019 28zm0-12a2 2 0 101.413 3.413l.02-.018A2 2 0 0019 16z",
    id: "scissors_svg__a"
  }));
};

var _default = SvgScissors;
exports["default"] = _default;